import client from "config/agent"
import { DataVisualizationRequest } from "types/data-visualization.types"
import { generateMockShipperAnalysisData } from "utils/mockShipperAnalysisData"

export interface DataVisualizationResult<T> {
  loading: boolean
  error: boolean
  data: T | null
}

export class DataVisualizationRestService {
  /**
   * Fetch ops analysis data from REST endpoint
   * @param request - Complete data visualization request
   * @returns Promise with analysis data
   */
  async fetchOpsAnalysis(request: DataVisualizationRequest): Promise<DataVisualizationResult<any>> {
    try {
      const requestBody = this.buildOpsAnalysisRequest(request)

      const response = await client.post("/data-visualization/ops-analysis", requestBody)

      return {
        loading: false,
        error: false,
        data: response.data,
      }
    } catch (error) {
      console.error("Error fetching ops analysis from REST endpoint:", error)

      // For development/testing, return mock data
      if (process.env.NODE_ENV === "development" || process.env.REACT_APP_STAGE === "development") {
        console.log("Using mock data for development")
        return {
          loading: false,
          error: false,
          data: generateMockShipperAnalysisData(),
        }
      }

      return {
        loading: false,
        error: true,
        data: null,
      }
    }
  }

  /**
   * Build request body for ops analysis REST API call
   * @param request - Complete data visualization request
   * @returns API request body object
   */
  private buildOpsAnalysisRequest(request: DataVisualizationRequest): DataVisualizationRequest {
    // Format dates if they exist
    const formattedRequest: DataVisualizationRequest = {
      ...request,
      period: {
        ...request.period,
        startDate: request.period.startDate ? new Date(request.period.startDate) : undefined,
        endDate: request.period.endDate ? new Date(request.period.endDate) : undefined,
      },
    }

    return formattedRequest
  }
}

// Export singleton instance
export const dataVisualizationRestService = new DataVisualizationRestService()
